import { useState, useEffect, createContext } from "react";
import ProviderTheme from "./contexts/ProviderTheme";
import ProviderWeb3 from "./contexts/ProviderWeb3";
import axios from "axios";
import { URI } from "./helpers";

export const contextProvider = createContext();

const Providers = ({ children }) => {

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");

  function setFilterCategory (id) {
    setFilter(id);
  }

  useEffect(() => {
    getProducts();
    getCategories();
  }, []);

  const getProducts = async () => {
    setLoading(true);
    const result = await axios.get(`${URI}products`);
    setProducts(result.data);
    setLoading(false);
  };

  const getCategories = async () => {
    const result = await axios.get(`${URI}categories`);
    setCategories(result.data);
  };


  return (
    <contextProvider.Provider
      value={{ products, loading, getProducts, filter, setFilterCategory, categories }}
    >
      <ProviderTheme>
        <ProviderWeb3>{children}</ProviderWeb3>
      </ProviderTheme>
    </contextProvider.Provider>
  );
};

export default Providers;
